import React from 'react';
import { Container } from '@mui/material';
import NavLinks from './NavLinks';
import LanguageList from './LanguageList';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Navmenu = () => {
    const currentLanguage = useSelector((state) => state.WebsiteLanguage.data.language);
    const logoSrc = `/img/logo/web/apk-logo-${currentLanguage || 'sq'}.png`;

    return (
        <Container maxWidth="xl">
            <div className="navmenu">
                <Link to="/" className='logo'> <img src={logoSrc} alt="Logo" /></Link>
                <NavLinks />
                <LanguageList />
            </div>
        </Container>
    )
}

export default Navmenu